import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '../services/translate-service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RestCallOriginService } from '../services/rest-call/rest-call-origin.service';
import { MessageOption } from './models/message-option';
import { ChatMessage } from './models/message';

@Injectable({
  providedIn: 'root'
})
export class InteractiveHelpService extends RestCallOriginService {
  languages: Array<any> = [];

  constructor(
    public httpClient: HttpClient,
    public translate: TranslateService) {
    super(httpClient, 'InteractiveHelp', null, null, translate);
  }

  public getMessages(clientId) {
    return this.get<ChatMessage[]>('Message/GetMessageByApplication/' + clientId);
  }

}
